<div class="pmd-footer bg-dark pmd-footer-dark secondary-footer">
   <div class="container">
      <div class="row align-items-end">
         <div class="col-12 col-md-4 mb-3 mb-md-0">
            <ul class="pmd-footer-nav pmd-footer-nav-divider mb-2 order-1">
               <li><a href="javscript:voide(0)" aria-label="Press enter to open about page">About</a></li>
               <li><a href="javscript:voide(0)" aria-label="Press enter to open Support page">Support</a></li>
               <li><a href="javscript:voide(0)" aria-label="Press enter to open privacy policy page ">Privacy</a></li>
               <li><a href="javscript:voide(0)" aria-label="Press enter to open terms of use page">Terms</a></li>
            </ul>
            <div class="pmd-site-info text-white opacity-50 ">
               <p class="" tabindex="0" >&copy; {{currentYear}} <strong class="font-heading text-white">PayKanz.</strong> All Rights Reserved <span class="ms-1">v{{appVersion}}</span></p>
            </div>
         </div>
         <div class="col-12 col-md-4 mb-2 mb-md-0 text-md-center order-first order-md-0 mb-4">
           <img src="./assets/images/kanz-logo-white.png">
         </div>
         <div class="col-md-4 col-12">
            <div class="pmd-site-info text-md-right text-white order-3">
               <p class="" tabindex="0" >We empower merchants from small, medium and big business to buy and sell online, extending the reach of financial services throughout Kuwait.</p>
            </div>
         </div>
      </div>
   </div>
</div>
